<div class="form-sec">
  <div class="row" *ngIf="reportType===8">
    <div class="col-md-10 col-lg-10">
      <h3>Shipping Availability Report</h3>
    </div>
    <div class="col-md-2 col-lg-2 text-right m-auto">
      <img src="../assets/icon/svg/manage-reports.svg" (click)="selectFilter()" />
      <a href="Javascript:void(0);" style="color: #0b3f54; padding:15px;" (click)="selectFilter()">MANAGE REPORTS</a>
    </div>
  </div>
  <div class="row margin-md-b10">
    <div class="col-sm-{{compomentWidth}}  col-md-{{compomentWidth}} col-lg-{{compomentWidth}} smallPadRgt0 margin-l0">
      <div class="row search-box-outer ">
        <div class="col-5 col-md-4 col-lg-3 padding-r0 category-drop-outer borderRight border-sm">
          <div class="category-dropdown material-select">
            <ng-select name="ddlOptions"
                       [(ngModel)]="selectedValue"
                       [virtualScroll]="true"
                       [closeOnSelect]="true"
                       [disabled]="isDisableWholeFilter"
                       [selectOnTab]="true"
                       [clearable]="false"
                       labelForId="name"
                       [searchable]="false"
                       (change)="filterOptionChange()">
              <ng-option *ngFor="let option of optionsData; let i = index;" [value]="option.key">
                <span [attr.data-testid]="'ddl-filter-opt_'+i">{{option.label}}</span>
              </ng-option>
            </ng-select>
          </div>
        </div>
        <div class="col-{{isSearchButtonOutside ? 7 : 7}}  col-md-{{isSearchButtonOutside ? 8 : 6}} col-lg-{{isSearchButtonOutside ? 9 : 7}} border-sm">
          <div *ngIf="selectedOption?.controlType === controlType.Text" class="material-select seed-search-filter" [ngClass]="isDisableWholeFilter ?'updateFontColor':''">
            <div class="search-box-outer" #productSearch>
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="retainFilter(txtCtrl)" [(ngModel)]="selectedOption.filterValue" [disabled]="isDisableWholeFilter == true ?'disable':null"
                         placeholder="Search..." type="text">
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="selectedOption?.controlType === controlType.Comparison" class="material-select seed-search-filter" #productSearch [ngClass]="{'notch-arrow': !isSearchButtonOutside, 'notch-outside': isSearchButtonOutside}">
            <div class="search-box-outer">
              <div class="row">
                <div class="col-md-1 col-1">
                  <span class="compareDropdown">
                    <ng-select #select
                               [items]="selectedOption.controlData"
                               [(ngModel)]="selectedOption.filterOperator"
                               [virtualScroll]="true"
                               [disabled]="selectedOption.controlData?.length == 0 || isDisableWholeFilter"
                               class="custom-select-grower comparison-select"
                               [clearable]="false"
                               [closeOnSelect]="true"
                               bindLabel="{{selectedOption.controlDataBindLabel}}"
                               bindValue="{{selectedOption.controlDataBindLabel}}">
                    </ng-select>
                  </span>
                </div>
                <div class="col-11 col-md-11">
                  <div class="search-box-outer chnageQuantityInput margin-l10" [ngClass]="isDisableWholeFilter ?'updateFontColor':''">
                    <div class="search-box wide90">
                      <span class="search-icon">
                        <i class="fas fa-search"></i>
                      </span>
                      <div class="select-container">
                        <input (keyup.enter)="retainFilter();" placeholder="Search..." [disabled]="isDisableWholeFilter == true ?'disable':null" type="text" [(ngModel)]="selectedOption.filterValue">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="selectedOption?.controlType === controlType.Integer" class="wide100 row material-select seed-search-filter" #productSearch [ngClass]="{'notch-arrow': !isSearchButtonOutside, 'notch-outside': isSearchButtonOutside}">
            <div class="search-box-outer" [ngClass]="isDisableWholeFilter ?'updateFontColor':''">
              <div class="search-box wide100">
                <span class="search-icon">
                  <i class="fas fa-search"></i>
                </span>
                <div class="select-container">
                  <input (keyup.enter)="retainFilter()" [(ngModel)]="selectedOption.filterValue" [disabled]="isDisableWholeFilter == true ?'disable':null"
                         placeholder="Search..." type="text" pattern="^[0-9, ]+$" NumbersOnly maxlength="20">
                </div>
              </div>
            </div>
          </div>
          <div class="material-select seed-search-filter" #productSearch [ngClass]="{'notch-arrow': !isSearchButtonOutside, 'notch-outside': isSearchButtonOutside}" *ngIf="selectedOption?.controlType === controlType.MultiDropDown" style="display: flex; gap: 10px;">
            <!-- Maturity From (Min) Dropdown -->
            <div class="flex-fill" >
              <ng-select #maturityFromSearch name="ddl{{selectedOption.key}}"
                         [items]="selectedOption.controlData"
                         placeholder="Min"
                         class="custom-select-grower"
                         [(ngModel)]="selectedOption.fromFilterValue"
                         [virtualScroll]="true"
                        bindLabel="{{selectedOption.controlDataBindLabel}}"
                        bindValue="{{selectedOption.controlDataBindLabel}}"
                         [clearable]="true"
                         [searchable]="true"
                         (change)="onMaturityFromChange();retainFilter(maturityFromSearch)">
                <ng-template ng-option-tmp let-item="item">
                  <div class="dropdown-template">
                    <p class="name">{{item.value}}</p>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
            </div>

            <!-- Maturity To (Max) Dropdown -->
            <div class="flex-fill" *ngIf="selectedOption?.controlType === controlType.MultiDropDown">
              <ng-select #maturityToSearch name="ddl{{selectedOption.key}}"
                         [items]="selectedOption.controlData"
                         placeholder="Max"
                         class="custom-select-grower"
                         [(ngModel)]="selectedOption.toFilterValue"
                         [virtualScroll]="true"
                         bindLabel="{{selectedOption.controlDataBindLabel}}"
                         bindValue="{{selectedOption.controlDataBindLabel}}"
                         [clearable]="true"
                         [searchable]="true"
                         (change)="onMaturityToChange();retainFilter(maturityToSearch)">
                <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                  <div class="dropdown-template" [attr.data-testid]="'ddl-'+selectedOption.key+'-option_'+index">
                    <div class="row">
                      <div class="col-md-8">
                        <p class="name">
                          {{item[selectedOption.controlDataBindLabel]}}
                        </p>
                      </div>
                    </div>
                  </div>
                </ng-template>
                <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                  <div class="ng-option disabled">
                    No data found for "{{searchTerm}}"
                  </div>
                </ng-template>
              </ng-select>
            </div>
          </div>

          <div class="row material-select seed-search-filter" [ngClass]="{'notch-arrow': !isSearchButtonOutside, 'notch-outside': isSearchButtonOutside}" *ngIf="selectedOption?.controlType === controlType.DropDown">
            <ng-select #ddlItem name="ddl{{selectedOption.key}}"
                       [(items)]="selectedOption.controlData"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="selectedOption.isMultiSelect"
                       [hideSelected]="true"
                       [(ngModel)]="selectedOption.filterValue"
                       [disabled]="selectedOption.controlData?.length == 0 || isDisableWholeFilter"
                       [virtualScroll]="true"
                       bindLabel="{{selectedOption.controlDataBindLabel}}"
                       bindValue="{{selectedOption.controlDataBindValue}}"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="retainFilter(ddlItem)"
                       [attr.data-testid]="'ddl-' + selectedOption.key + '-search'">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-'+selectedOption.key+'-option_'+index">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item[selectedOption.controlDataBindLabel]}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div class="row material-select seed-search-filter" [ngClass]="{'notch-arrow': !isSearchButtonOutside, 'notch-outside': isSearchButtonOutside}" *ngIf="selectedOption?.controlType === controlType.ValuesWithIDDropDown">
            <ng-select #ddlItem name="ddl{{selectedOption.key}}"
                       [(items)]="selectedOption.controlData"
                       placeholder="Search..."
                       class="custom-select-grower"
                       [multiple]="selectedOption.isMultiSelect"
                       [hideSelected]="true"
                       [(ngModel)]="selectedOption.filterValue"
                       [disabled]="selectedOption.controlData?.length == 0 || isDisableWholeFilter"
                       [virtualScroll]="true"
                       bindLabel="{{selectedOption.controlDataBindLabel}}"
                       bindValue="{{selectedOption.controlDataBindLabel}}"
                       [closeOnSelect]="true"
                       [searchFn]="filterSearchFn"
                       (change)="retainFilter(ddlItem)"
                       [attr.data-testid]="'ddl-' + selectedOption.key + '-search'">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template" [attr.data-testid]="'ddl-'+selectedOption.key+'-option_'+index">
                  <div class="row">
                    <div class="col-md-8">
                      <p class="name">
                        {{item[selectedOption.controlDataBindLabel]}}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div class="row material-select seed-search-filter" [ngClass]="{'notch-arrow': !isSearchButtonOutside, 'notch-outside': isSearchButtonOutside}" *ngIf="selectedOption?.controlType === controlType.AccountDropDown">
            <ng-select #ddlAccountItem name="ddlAccount{{selectedOption.key}}"
                       [items]="selectedOption.controlData"
                       [loading]="accountsLoading"
                       [(ngModel)]="selectedOption.filterValue"
                       [multiple]="selectedOption.isMultiSelect"
                       [virtualScroll]="true"
                       bindLabel="{{selectedOption.controlDataBindLabel}}"
                       bindValue="{{selectedOption.controlDataBindLabel}}"
                       [disabled]="selectedOption.controlData?.length == 0 || isDisableWholeFilter"
                       class="custom-select-grower searchIcon lpSearch"
                       placeholder="Select Account"
                       [closeOnSelect]="true"
                       [searchFn]="ddlAccountSearchFn"
                       (change)="retainFilter(ddlAccountItem)">
              <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                <div class="dropdown-template">
                  <div class="row" *ngIf="item.accountNumber!=-1">
                    <div class="col-md-8">
                      <h4 class="name" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="address" [ngOptionHighlight]="search">
                        {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                      </p>
                      <p class="phoneNo" [ngOptionHighlight]="search">
                        {{item.primaryPhoneNumber}}
                      </p>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                  <div class="row" *ngIf="item.accountNumber==-1">
                    <div class="col-md-8">
                      <h4 class="name" [ngOptionHighlight]="search">
                        {{item.accountName}}
                      </h4>
                      <p class="grower-nos">
                        <span class="grower-gln" [ngOptionHighlight]="search">
                          Account #: {{item.accountNumber}}
                        </span>
                      </p>
                    </div>
                  </div>
                </div>
              </ng-template>
              <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                <div class="ng-option disabled">
                  No data found for "{{searchTerm}}"
                </div>
              </ng-template>
              <ng-template ng-footer-tmp let-search="searchTerm">
                <div class="custom-drop-footer">
                  <div class="row">
                    <div class="col-md-12">
                      Select an option above to filter
                    </div>
                  </div>
                </div>
              </ng-template>
            </ng-select>
          </div>

          <div *ngIf="selectedOption?.controlType === controlType.DateRange" class="row">
            <div class="col-md-6 col-lg-6 borderRight mt-1">
              <mat-form-field class="ml-2 w-100">
                <input matInput [matDatepicker]="picker1" (focus)="picker1.open();" [disabled]="isDisableWholeFilter == true ?'disable':null" placeholder="From" [matDatepickerFilter]="selectedOption.fromDateValidateFilter"
                       readonly [(ngModel)]="selectedOption.fromFilterValue" (dateChange)="dateRangeFilterValidation('fromDate', $event); retainFilter();">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
            <div class="col-md-6 col-lg-6 mt-1">
              <mat-form-field class="w-100 pr-2">
                <input matInput [matDatepicker]="picker2" (focus)="picker2.open();" [disabled]="isDisableWholeFilter == true ?'disable':null" placeholder="To" [matDatepickerFilter]="selectedOption.toDateValidateFilter"
                       readonly [(ngModel)]="selectedOption.toFilterValue" (dateChange)="dateRangeFilterValidation('toDate', $event); retainFilter();">
                <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                <mat-datepicker #picker2></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="selectedOption?.controlType === controlType.Date" class="row">
            <div class="col-md-6 col-lg-6 mt-1">
              <mat-form-field class="ml-2 w-100">
                <input matInput [matDatepicker]="picker1" (focus)="picker1.open();" placeholder="Date" [disabled]="isDisableWholeFilter == true ?'disable':null"
                       readonly [(ngModel)]="selectedOption.filterValue" (dateChange)="retainFilter();">
                <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                <mat-datepicker #picker1></mat-datepicker>
              </mat-form-field>
            </div>
          </div>

          <div *ngIf="selectedOption?.controlType === controlType.CalendarMonthYear" class="row">
            <app-calendar-month-year placeholder="Month and Year" [(value)]="selectedOption.filterValue" [disabled]="isDisableWholeFilter" (monthSelected)="selectedOption.filterValue=$event; this.retainFilter()"></app-calendar-month-year>
          </div>
        </div>
        <!--  </div> -->
        <div *ngIf="showSearchButton && !isSearchButtonOutside" class="col-12 col-md-2 col-lg-2 padding-sm-0">
          <div class="search-btn xs-full-width mobile-pl-5" *ngIf="!isShowFilterButton">
            <button [disabled]="isDisableSearchButton || isDisableWholeFilter" mat-raised-button class="btns margin-t12" (click)="searchEmit()" color="primary" data-testid="btn-filter-search">Search</button>
          </div>
          <div class="search-btn xs-full-width mobile-pl-5" *ngIf="isShowFilterButton">
            <button [disabled]="isDisableSearchButton || isDisableWholeFilter" mat-raised-button class="btns margin-t12" (click)="searchEmit()" color="primary" data-testid="btn-filter-search">Filter</button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="chips-sec">
            <div class="row selected-chip">
              <div class="col-sm-8 col-md-10 padding-l0">
                <div>
                  <mat-chip-set>
                    <mat-chip selected *ngFor="let filterValue of filterValueList">
                      {{filterValue}}
                      <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                        <i class="fas fa-times text-right"></i>
                      </a>
                    </mat-chip>
                  </mat-chip-set>
                </div>
              </div>
              <div class="col-sm-2 col-md-2 text-right padding-r30" *ngIf="filterValueList.length > 0">
                <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-1 col-xl-1" *ngIf="showSearchButton && isSearchButtonOutside">
      <button [disabled]="isDisableSearchButton || isDisableWholeFilter" mat-raised-button class="btns margin-t12 margin-md-t0 btn-outside w100 w-sm-100" (click)="searchEmit()" color="primary" data-testid="btn-filter-search">Search</button>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-1 col-xl-1 padding-r0" *ngIf="reportType===8">
      <button mat-raised-button class="btns margin-t12 margin-md-t0 btn-outside wide100" [disabled]="(this.shippingAvailabilityList && this.shippingAvailabilityList.length <= 0) || isDisableWholeFilter " (click)="exportEmit()">Export</button>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-1 col-xl-1" *ngIf="reportType===8">
      <button mat-raised-button class="btns margin-t12 margin-md-t0 btn-outside wide100" [disabled]="(this.shippingAvailabilityList && this.shippingAvailabilityList.length <= 0) || isDisableWholeFilter" (click)="emailDataEmit()">Email</button>
    </div>

    <div class="col-md-12 padding-l30 padding-b10 padding-t10" *ngIf="reportType===8">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="row">
            <div class="col-sm-9 col-md-9 col-lg-9 col-xl-9 padding-r30 padding-l0 text-left">
              <div class="row">
                <div class="col-sm-3 col-md-3  col-lg-3 col-xl-3 padding-r30 padding-t5">
                  <p *ngIf="currentFilter.filterDescription">REPORT NAME: {{currentFilter.filterDescription}}</p>
                </div>
                <div class="col-sm-3 col-md-3  col-lg-3 col-xl-3 padding-r30 padding-t5">
                  <p *ngIf="currentFilter.filterDescription">
                    LAST RUN DATE: {{(currentFilter.lastRunByTimeStamp || currentFilter.createTimeStamp) | date: 'MM/dd/yyyy'}}
                  </p>
                </div>
                <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 padding-r30" *ngIf="currentFilter.filterDescription">
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="editFilter()" *ngIf="(currentFilter.userReportFilterId || !(currentFilter.userReportFilterId)) && currentFilter.filterDescription">Edit Report</button>
                  <button mat-raised-button class="btns margin-r10" color="primary" (click)="save()" *ngIf="currentFilter.filterDescription">Save</button>
                </div>
              </div>
            </div>
            <div class="col-sm-3 col-md-3 col-lg-3 col-xl-3 text-right">
              <div class="padding-r0 ">
                <button *ngIf="reportType===8 && hasReleaseOrderAccess" [disabled]="!isReleaseOrderEnable" mat-raised-button class="btns mr-2" color="primary" (click)="releaseOrder()">Release Order</button>
                <button mat-raised-button class="btns" color="primary" (click)="addFilter()">Create Report</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
